export default {
    "DeFi Binance": "DeFi Binance",
    "流动性挖矿": "Mineração de liquidez",
    "加入节点， 开始挖矿": "Participe do nó e comece a minerar",
    "参 与": "Participar",
    "矿池数据": "Dados do pool",
    "总产量": "Produção total",
    "有效节点": "Nós ativos",
    "参与者": "Participantes",
    "用户收入": "Renda do usuário",
    "挖矿榜单": "Ranking de mineração",
    "流动性挖矿收入": "Rendimentos da mineração de liquidez",
    "输出记录": "Registro de saídas",
    "地址": "Endereço",
    "数量": "Quantidade",
    "帮助中心": "Central de ajuda",
    "希望它可以帮助你": "Esperamos que te ajude",
    "安全保障": "Garantia de segurança",
    "我们有安全的审计报告": "Temos relatórios de auditoria seguros",
    "伙伴": "Parceiros",
    "我们的商业伙伴": "Nossos parceiros comerciais",
    "首页": "Início",
    "我的矿池": "Meu pool de mineração",
    "提取": "Sacar",
    "账户": "Conta",
    "总挖矿金额": "Valor total minerado",
    "可更换": "Convertível",
    "收益率": "Taxa de retorno",
    "币池名称": "Nome do pool",
    "最低金额": "Valor mínimo",
    "收益率/24小时": "Taxa de retorno/24h",
    "挖矿记录": "Registro de mineração",
    "金额": "Valor",
    "描述": "Descrição",
    "时间": "Hora",
    "已参与": "Participado",
    "质 押": "Staking",
    "已质押": "Em staking",
    "记录": "Registro",
    "兑换": "Trocar",
    "从": "De",
    "全部": "Todos",
    "至": "Até",
    "价格": "Preço",
    "确认": "Confirmar",
    "矿池收益": "Rendimento do pool",
    "今日收益": "Rendimento de hoje",
    "普通矿池": "Pool padrão",
    "高级矿池": "Pool avançado",
    "全部的": "Todos",
    "可用的": "Disponível",
    "申请加入": "Solicitar adesão",
    "推荐朋友": "Indicar amigos",
    "一起赚取加密货币": "Ganhe cripto juntos",
    "查看详情": "Ver detalhes",
    "团队": "Equipe",
    "推荐": "Indicação",
    "团队规模": "Tamanho da equipe",
    "直接发起人": "Patrocinador direto",
    "总收入": "Renda total",
    "今天的收入": "Renda de hoje",
    "我的推荐链接": "Meu link de indicação",
    "复制": "Copiar",
    "1. 获取链接": "1. Obtenha o link",
    "2. 邀请朋友": "2. Convide amigos",
    "3. 赚取加密货币": "3. Ganhe criptomoedas",
    "等级": "Nível",
    "1 级": "Nível 1",
    "2 级": "Nível 2",
    "3 级": "Nível 3",
    "用户地址": "Endereço do usuário",
    "币种": "Token",
    "说明": "Detalhes",
    "状态": "Status",
    "定时收益": "Rendimentos programados",
    "今日预收益": "Rendimentos previstos hoje",
    "累计收益": "Rendimentos acumulados",
    "将矿池收益的BNB兑换成USDT后立即到账": "Converta o rendimento do pool de BNB para USDT instantaneamente",
    "将USDT提取后会在24小时内到达你的钱包": "A retirada de USDT chegará no seu bolso dentro de 24h",
    "天": "Dias",
    "高级矿池收益": "Rendimento do pool avançado",
    "质押收益": "Rendimentos de staking",
    "下次收益": "Próximos rendimentos",
    "当前收益率": "Taxa de retorno atual",
    "昨日收益": "Rendimentos de ontem",
    "普通矿池收益率": "Taxa de retorno do pool padrão",
    "高级矿池收益率": "Taxa de retorno do pool avançado",
    "高级矿池限时开放": "Pool avançado aberto por tempo limitado",
	"公告":"anúncio",
	"我知道了":"OK"
};
